import axios from 'axios'
const service = axios.create({
    // baseURL: "http://192.168.201.94:8081/api/v1/",
    baseURL:'https://mt.hkaspire.net/api/v1',
    timeout: 60000
});

service.interceptors.request.use(
    config => {
        if(sessionStorage.getItem('token')){
            config.headers.Authorization = sessionStorage.getItem('token')
        }
      return config;
    },
    err => {
      return Promise.reject(err);
    }
);


class http{
    static post(url,data){
        return new Promise(function(resolve,reject){
            service.post(url,data).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }

    static get(url){
        return new Promise(function(resolve,reject){
            service.get(url).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }

    // 移动端弹出层滚动不影响body
    static divScroll(layerNode){
        if(!document.querySelector(layerNode)) return;
        this.popupLayer=document.querySelector(layerNode);
        this.startX=0;
        this.startY=0;
        this.popupLayer.addEventListener('touchstart',function(e){
            this.startX=e.changedTouches[0].pageX;
            this.startY=e.changedTouches[0].pageY;
        },false);

        this.popupLayer.addEventListener('touchmove',function(e){
            e.stopPropagation();
            var deltaX=e.changedTouches[0].pageX-this.startX;
            var deltaY=e.changedTouches[0].pageY-this.startY;
            if(Math.abs(deltaY)<Math.abs(deltaX)){
                e.preventDefault();
                return false;
            }
            if(this.offsetHeight+this.scrollTop>=this.scrollHeight){
                if(deltaY<0){
                    e.preventDefault();
                    return false;
                }
            }
            if(this.scrollTop === 0){
                if(deltaY > 0) {
                    e.preventDefault();
                    return false;
                }
            }
        },false);
    }
}


export default http;



// WEBPACK FOOTER //
// ./src/common/http.js